import { useSession, signOut } from "next-auth/react";
import { useEffect } from "react";
import { UN_AUTHENTICATED, URLS } from "@/constants/constants";

export const useKeycloakSession = () => {
  const { data: session, status, update } = useSession();

  useEffect(() => {
    if (globalThis.window !== undefined && status === UN_AUTHENTICATED) {
      const currentPath = globalThis.location.pathname;
      const isLoginPage = currentPath === URLS.LOGIN;
      if (!isLoginPage) {
        signOut({ callbackUrl: URLS.LOGOUT });
      }
    }
  }, [status, session]);

  return { session, status, update };
};
